"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.InstallAppOutsideSandboxError = void 0;
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const localizeUtils_1 = require("../../../common/localizeUtils");
class InstallAppOutsideSandboxError extends teamsfx_api_1.UserError {
    constructor(actionName) {
        super({
            source: actionName,
            name: "InstallAppOutsideSandbox",
            message: (0, localizeUtils_1.getDefaultString)("error.installApp.outsideSandbox"),
            displayMessage: (0, localizeUtils_1.getLocalizedString)("error.installApp.outsideSandbox"),
        });
    }
}
exports.InstallAppOutsideSandboxError = InstallAppOutsideSandboxError;
//# sourceMappingURL=errors.js.map